// extracted by mini-css-extract-plugin
export default {"wrapper":"notFound_wrapper__WuU3w"};